module.exports = "./img/fba39227245d5f7df38dfcaf9177ae43.jpg";